import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import BirthdaySettings from "../../components/BirthdaySettings";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: 0,
    overflowY: "scroll",
    background: "transparent",
    border: "none",
    boxShadow: "none",
    ...theme.scrollbarStyles,
  },
}));

const BirthdaySettingsPage = () => {
  const classes = useStyles();

  return (
    <MainContainer>
      <Paper className={classes.mainPaper} variant="outlined">
        <BirthdaySettings />
      </Paper>
    </MainContainer>
  );
};

export default BirthdaySettingsPage;